import { form } from './variables';

/**
 * Display name for a procedure in the widget.
 *
 * On channels using the "How would you like to meet?" step
 * (delivery_mode_selection), virtual and phone services carry a
 * "(Virtual · Telehealth)" / "(Phone)" style suffix in their DB name —
 * required for uniqueness and (for telehealth) the EHR sync mode flag — but
 * it's redundant on screen once the visitor has already chosen the mode.
 * Strip a trailing parenthetical that mentions virtual/telehealth/phone for
 * display only. Channels without the mode step are untouched.
 */
export function procedureDisplayName(procedure) {
    const name = procedure?.name ?? '';
    if (!form?.appointment_channel?.delivery_mode_selection) return name;
    if (procedure?.service_delivery_mode === 'fully_virtual') {
        return name.replace(/\s*\((?=[^)]*(?:virtual|telehealth))[^)]*\)\s*$/i, '');
    }
    if (procedure?.service_delivery_mode === 'phone_consultation') {
        return name.replace(/\s*\((?=[^)]*(?:phone|call))[^)]*\)\s*$/i, '');
    }
    return name;
}
